import queryString from "query-string";
import React from "react";
import { Link } from "react-router-dom";
import RelatorioCotacoes from "../../components/RelatorioCotacoes/RelatorioCotacoes";
import RelatorioEncomendas from "../../components/RelatorioEncomendas/RelatorioEncomendas";
import { RelatoriosPageStyle } from "./style";

function Relatorios(props) {
  const tipo = queryString.parse(props.location.search).tipo || "encomendas";

  return (
    <div className="page-container-style">
      <RelatoriosPageStyle>
        <h2 className="page-title">
          {tipo === "cotacoes" ? "Relatório de Cotações" : "Relatório de Encomendas"}
        </h2>
        <nav className="relatorios-tabs">
          <Link
            className={`relatorios-tab${tipo === "encomendas" ? " active" : ""}`}
            to="/relatorios?tipo=encomendas"
          >
            Encomendas
          </Link>
          <Link
            className={`relatorios-tab${tipo === "cotacoes" ? " active" : ""}`}
            to="/relatorios?tipo=cotacoes"
          >
            Cotações
          </Link>
        </nav>
        <div className="relatorios-conteudo">
          {tipo === "cotacoes" ? <RelatorioCotacoes /> : <RelatorioEncomendas />}
        </div>
      </RelatoriosPageStyle>
    </div>
  );
}

export default Relatorios;
